import React from "react";
import { beforeAfter } from "../mock";
import { ArrowUpRight } from "lucide-react";

const hiRes = (url, w) => `${url}&width=${w}`;

export default function BeforeAfter() {
  return (
    <section className="section bg-[#F5EFE6]">
      <div className="container-y flex flex-col gap-20">
        {beforeAfter.map((b, idx) => (
          <div
            key={idx}
            className={`grid grid-cols-1 lg:grid-cols-[1.25fr_1fr] gap-10 lg:gap-16 items-center ${
              idx % 2 === 1 ? "lg:[direction:rtl]" : ""
            }`}
          >
            <div className="grid grid-cols-2 [direction:ltr] overflow-hidden rounded-sm shadow-xl">
              <div className="relative">
                <img
                  src={hiRes(b.beforeImg, 1000)}
                  srcSet={`${hiRes(b.beforeImg, 600)} 600w, ${hiRes(b.beforeImg, 1000)} 1000w, ${hiRes(b.beforeImg, 1400)} 1400w`}
                  sizes="(max-width: 1024px) 50vw, 32vw"
                  alt="Before"
                  className="w-full aspect-[3/4] object-cover"
                  loading="lazy"
                  data-testid={`before-img-${idx}`}
                />
                <span className="absolute bottom-4 left-4 bg-[#1a1a1a] text-[#FBF8F4] text-[11px] tracking-[0.2em] uppercase px-3 py-1.5">
                  {b.leftLabel}
                </span>
              </div>
              <div className="relative">
                <img
                  src={hiRes(b.afterImg, 1000)}
                  srcSet={`${hiRes(b.afterImg, 600)} 600w, ${hiRes(b.afterImg, 1000)} 1000w, ${hiRes(b.afterImg, 1400)} 1400w`}
                  sizes="(max-width: 1024px) 50vw, 32vw"
                  alt="After"
                  className="w-full aspect-[3/4] object-cover"
                  loading="lazy"
                  data-testid={`after-img-${idx}`}
                />
                <span className="absolute bottom-4 left-4 bg-[#C9A961] text-[#1a1a1a] text-[11px] tracking-[0.2em] uppercase px-3 py-1.5">
                  {b.rightLabel}
                </span>
              </div>
            </div>

            <div className="[direction:ltr]">
              <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-3">
                Real Results
              </p>
              <h3 className="font-serif-y text-3xl md:text-4xl text-[#1a1a1a] mb-5">{b.title}</h3>
              <p className="font-sans-y text-[15px] text-[#444] leading-relaxed mb-3">{b.quote}</p>
              <p className="font-serif-y text-[15px] text-[#7a7a7a] italic mb-8">— {b.author}</p>
              <a href={b.href} target="_blank" rel="noreferrer" className="btn-y-outline">
                Shop {b.collection} <ArrowUpRight size={14} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
